import { useState } from "react";
import Cart from "../Cart/Cart";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

const Contact = ({
  navigate,
  pathname,
  cart,
  total,
  removeFromCart,

  setCurrentPage,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [activeTab, setActiveTab] = useState("contact");
  const [cartOpen, setCartOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for your message! We'll get back to you soon.");
    setFormData({ name: "", email: "", message: "" });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const contactInfo = [
    {
      icon: "📍",
      title: "Visit Our Store",
      content:
        "Chagani Studio DC 2 Delawala Shopping centre next to marine point Clifton block 9, Karachi Lines, Pakistan, 75600",
      details: "Mon-Fri: 9AM-9PM, Sat-Sun: 10AM-8PM",
    },
    {
      icon: "📞",
      title: "Call Us",
      content: "0300 9254076",
      details: "24/7 Support Hotline",
    },
    {
      icon: "✉️",
      title: "Email Support",
      content: "info@gameshub.com",
      details: "We respond within 2 hours",
    },
  ];

  const faqs = [
    {
      question: "How do I track my order?",
      answer:
        "You can track your order by logging into your account and visiting the 'Order History' section. You'll find a tracking number and link to the shipping carrier's website.",
    },
    {
      question: "What is your return policy?",
      answer:
        "We offer a 30-day return policy for all games and accessories. Items must be in original condition with all packaging and documentation. Digital downloads are not eligible for returns.",
    },
    {
      question: "Do you offer international shipping?",
      answer:
        "Yes, we ship to over 50 countries worldwide. International shipping rates vary by location and order value. Free shipping is available for international orders over $100.",
    },
    {
      question: "How do I redeem a gift card?",
      answer:
        "Gift cards can be redeemed during checkout by entering the code in the 'Gift Card' field. The amount will be automatically applied to your order total.",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Header
        cartCount={0}
        onCartClick={() => setCartOpen(true)}
        searchTerm=""
        setSearchTerm={() => {}}
        currentPage="contact"
        setCurrentPage={setCurrentPage}
      />

      {/* Fancy Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 opacity-90"></div>
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6 tracking-tight">
              Get in <span className="text-yellow-300">Touch</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
              Have questions? Need support? We're here to help you level up your
              gaming experience
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-4 mb-8">
              <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-6 py-3">
                <span className="text-white font-semibold">
                  📞 24/7 Support
                </span>
              </div>
              <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-6 py-3">
                <span className="text-white font-semibold">
                  ⚡ Quick Response
                </span>
              </div>
              <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full px-6 py-3">
                <span className="text-white font-semibold">
                  🎮 Gaming Experts
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Tab Navigation */}
        <div className="flex justify-center mb-12">
          <div className="bg-white rounded-lg shadow-md p-1">
            <button
              onClick={() => setActiveTab("contact")}
              className={`px-6 py-3 rounded-md font-semibold transition duration-200 ${
                activeTab === "contact"
                  ? "bg-red-600 text-white shadow-sm"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              Contact Us
            </button>
            <button
              onClick={() => setActiveTab("faq")}
              className={`px-6 py-3 rounded-md font-semibold transition duration-200 ${
                activeTab === "faq"
                  ? "bg-red-600 text-white shadow-sm"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              FAQ
            </button>
          </div>
        </div>

        {activeTab === "contact" && (
          <>
            {/* Contact Information Cards */}
            <section className="mb-16">
              <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
                Multiple Ways to Reach Us
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {contactInfo.map((info, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition duration-300 transform hover:-translate-y-2"
                  >
                    <div className="text-6xl mb-4">{info.icon}</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {info.title}
                    </h3>
                    <p className="text-gray-900 font-semibold mb-2">
                      {info.content}
                    </p>
                    <p className="text-gray-600 text-sm">{info.details}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Enhanced Contact Form */}
            <section className="mb-16">
              <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                  <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-8 text-white text-center">
                    <h2 className="text-3xl font-black mb-2">
                      Send Us a Message
                    </h2>
                    <p className="text-blue-100">
                      We'll get back to you within 24 hours
                    </p>
                  </div>
                  <form onSubmit={handleSubmit} className="p-8 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Full Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                          placeholder="Your full name"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
                          placeholder="your@email.com"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Subject
                      </label>
                      <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200">
                        <option>General Inquiry</option>
                        <option>Order Support</option>
                        <option>Technical Support</option>
                        <option>Partnership</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Message
                      </label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="6"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200 resize-none"
                        placeholder="Tell us how we can help you..."
                        required
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 px-6 rounded-lg font-bold text-lg hover:shadow-lg transition duration-300 transform hover:scale-105"
                    >
                      Send Message 🚀
                    </button>
                  </form>
                </div>
              </div>
            </section>

            {/* Social Media Section */}
            <section className="mb-16">
              <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
                Follow Us on Social Media
              </h2>
              <div className="flex justify-center space-x-8">
                <a
                  href="https://www.facebook.com/profile.php?id=100083751172233"
                  className="bg-blue-600 text-white p-4 rounded-full hover:bg-blue-700 transition duration-300 transform hover:scale-110"
                >
                  <span className="text-2xl">📘</span>
                </a>
                {/* <a
                  href="#"
                  className="bg-blue-400 text-white p-4 rounded-full hover:bg-blue-500 transition duration-300 transform hover:scale-110"
                >
                  <span className="text-2xl">🐦</span>
                </a> */}
                <a
                  href="https://www.instagram.com/gameshub14/"
                  className="bg-pink-600 text-white p-4 rounded-full hover:bg-pink-700 transition duration-300 transform hover:scale-110"
                >
                  <span className="text-2xl">📷</span>
                </a>
                <a
                  href="https://www.youtube.com/@gameshub-official/videos"
                  className="bg-red-600 text-white p-4 rounded-full hover:bg-red-700 transition duration-300 transform hover:scale-110"
                >
                  <span className="text-2xl">🎥</span>
                </a>
                {/* <a
                  href="#"
                  className="bg-purple-600 text-white p-4 rounded-full hover:bg-purple-700 transition duration-300 transform hover:scale-110"
                >
                  <span className="text-2xl">🎮</span>
                </a> */}
              </div>
            </section>
          </>
        )}

        {activeTab === "faq" && (
          <section>
            <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
              Frequently Asked Questions
            </h2>
            <div className="max-w-3xl mx-auto space-y-6">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Call to Action */}
        {/* <section className="text-center mt-16">
          <div className="bg-gradient-to-r from-green-500 to-blue-600 rounded-2xl p-12 text-white">
            <h2 className="text-4xl font-black mb-4">Still Need Help?</h2>
            <p className="text-xl mb-8 text-green-100">
              Our support team is always ready to assist you
            </p>
            <div className="flex justify-center space-x-4">
              <button className="bg-white text-green-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 hover:shadow-lg transition duration-300 transform hover:scale-105">
                Start Live Chat
              </button>
              <button className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-green-600 transition duration-300">
                Call Support
              </button>
            </div>
          </div>
        </section> */}
      </main>

      <Footer />
      {cartOpen && (
        <Cart
          cart={cart}
          total={total}
          onRemove={removeFromCart}
          onClose={() => setCartOpen(false)}
          onCheckout={() => {
            navigate("/checkout");
            setCartOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default Contact;
